import React, {Component} from 'react';
import PropTypes from 'prop-types';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import {getText} from 'helpers/language-helper';
import {errorUiTexts} from 'data/ui-texts/error-ui-texts';
import AdminLogin from './admin-login';
import AdminController from 'components/users/admin-controller';

class AdminLoginController extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: false,
			isLoggedIn: false,
			authData: null,
			email: null,
			password: null,
			feedback: null
		};
		this.unsubscribeOnAuthStateChanged = null;
	}

	/**
	 * Component did mount
	 */
	componentDidMount = () => {
		/* Check if logged in */
		this.checkIfLoggedIn();
	};

	/**
	 * Component will unmount
	 */
	componentWillUnmount = () => {
		if (this.unsubscribeOnAuthStateChanged !== null) this.unsubscribeOnAuthStateChanged();
	};

	/**
	 * Check if user is logged in
	 */
	checkIfLoggedIn = () => {
		// Unsubscribe previous onAuthStateChanged
		if (this.unsubscribeOnAuthStateChanged !== null) {
			this.unsubscribeOnAuthStateChanged();
		}

		// Subscribe to onAuthStateChanged
		this.unsubscribeOnAuthStateChanged = firebase.auth().onAuthStateChanged((user)=>{
			if (user && user.email) {
				this.setState({
					isLoggedIn: true,
					isLoading: false,
					email: null,
					password: null,
					feedback: null,
					authData: {
						userId: user.uid,
						email: user.email
					}
				});
			} else {
				this.setState({
					isLoading: false,
					isLoggedIn: false,
					authData: null,
					email: null,
					password: null,
					feedback: null
				});
			}
		});	
	};

	/**
	 * Update input field
	 * @param {obj} event 
	 */
	handleInput = (event) => {
		let value = event.target.value;
		let name = event.target.name;
		this.setState({
			[name]: value,
			feedback: null
		});
	};

	/**
	 * Logout
	 */
	handleLogout = () => {		
		firebase.auth().signOut();
		this.setState({
			isLoading: false,
			isLoggedIn: false,
			userId: null,
			email: null,
		});
	};


	/**
	 * Handle login
	 * @param {obj} event 
	 */
	handleLogin = (event) => {
		if (event) event.preventDefault();
		this.setState({isLoading: true, fedback: null}, () => {
			let feedback = null;

			/* Check if e-mail / password is okay */
			const email = this.state.email;
			const password = this.state.password;
			if (!feedback && (!email || !password)) {
				feedback = getText(errorUiTexts.emptyFields, this.props.languageId);
			}

			if (!feedback) {
				firebase.auth().signInWithEmailAndPassword(email, password)
					.catch((error) => {
						if (error.code === 'auth/user-not-found') {
							feedback = getText(errorUiTexts.emailNotFound, this.props.languageId);
						}
						if (error.code === 'auth/wrong-password') {
							feedback = getText(errorUiTexts.invalidEmailPasswordFormat, this.props.languageId);
						}
						if (error.code === 'auth/invalid-email') {
							feedback = getText(errorUiTexts.invalidEmail, this.props.languageId);
						}
						if (!feedback) {
							console.error(error);
							feedback = getText(errorUiTexts.unknownError, this.props.languageId);
						}
						this.setState({isLoading: false, feedback});
					});
			} else {
				this.setState({isLoading: false, feedback});
			}
		});
	};


	/**
 	* Render component
 	*/
	render = () => {
		if (this.state.isLoading || !this.state.isLoggedIn) {
			return (
				<AdminLogin 
					isLoading={this.state.isLoading}
					languageId={this.props.languageId}
					email={this.state.email}
					password={this.state.password}
					feedback={this.state.feedback}
					handleLogin={this.handleLogin}
					handleInput={this.handleInput}
				/>
			);
		}

		return (
			<AdminController 
				languageId={this.props.languageId}
				email={this.state.authData.email}
				scrollToTop={this.props.scrollToTop}
				handleLogout={this.handleLogout}
			/>
		);
	};
}

AdminLoginController.propTypes = {
	languageId: PropTypes.string.isRequired,
	scrollToTop: PropTypes.func.isRequired,
};

export default AdminLoginController;